import React, { useEffect, useRef, useState } from 'react'
import { Col, Row, Accordion, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faEye, faPlane, faTruck, faXmark, faAnglesLeft } from '@fortawesome/free-solid-svg-icons';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import pieces from "../../../../assets/images/pieces.png";
import shipment_tracking from "../../../../assets/images/shipment_tracking.png";
import { withRFSToken } from '../../../../Services/axios';
import Cargotruck from "../../../../assets/images/cargo-truck.png"
import BlueFlight from "../../../../assets/images/blueFlight.jpg";
import CargoTruck from "../../../../assets/images/cargo-truck.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});
const FitBounds = ({ positions }) => {
  const map = useMap();

  useEffect(() => {
    if (positions.length > 0) {
      const bounds = L.latLngBounds(positions);
      map.fitBounds(bounds, { padding: [50, 50] }); // padding to avoid edges
    }
  }, [positions, map]);

  return null;
};

const Overview = ({ fData }) => {
  // console.log('fData',fData);
  
  // const positionA = [45.9234, 6.6849];
  // const positionB = [48.8566, 2.3522];
  // const positionC = [47.0854, 2.0416];
  // const positions = [positionA, positionB, positionC];



  const [routes, setRoutes] = useState();
  const [htmlContent, setHtmlContent] = useState();
  const [awbDetails, setAwbDetails] = useState();
  const [open, setOpen] = useState(false);
  const planeProgress = "45%";
  let storedData = localStorage.getItem('OVDetails');
  if (storedData) {
    storedData = JSON.parse(storedData)
  }
  const isMounted = useRef(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const detailsData = JSON.parse(localStorage.getItem('OVDetails'))
  useEffect(() => {
    // if (isMounted.current) return;
    // fetchAwbDetails();
    setSelectedRowData(fData)
    setAwbDetails(fData?.ULD.data);
    let departureDate = null;
    let departureTime = null;
    let previousArrival = null;
    let htmlContent = '';
    const routes = fData?.ULD?.movements?.map(movement => {

      let imageFile = null;
      let Boardpoint = '';
      let Offpoint = '';
      let allDateTime = null;
      let connectionTime = null;
      let connectionDetailsTime = null;
      if (movement.type === 'Flight') {
        let arrivalDateTime = movement.flight_schedule?.arrival_date_utc ?? null;
        let departureDateTime = movement.flight_schedule?.departure_date_utc ?? null;

        let arrivalDate = arrivalDateTime ? arrivalDateTime.split(' ')[0] : null;
        let arrivalTime = arrivalDateTime ? arrivalDateTime.split(' ')[1] : null;
        let depDate = departureDateTime ? departureDateTime.split(' ')[0] : null;
        let depTime = departureDateTime ? departureDateTime.split(' ')[1] : null;
        if (previousArrival && depDate && depTime) {
          let prev = new Date(previousArrival);
          let curr = new Date(`${depDate}T${depTime}`);
          let diffMinutes = (curr - prev) / (1000 * 60); // in minutes
          if (diffMinutes >= 0) connectionTime = formatMinutesToHHMM(diffMinutes);
          connectionTime = (diffMinutes >= 0 ? '' : '-') + formatMinutesToHHMM(Math.abs(diffMinutes));
          connectionDetailsTime = (diffMinutes >= 0 ? '' : '-') + "Prev-" + previousArrival + "<br/>Curr" + `${depDate}T${depTime}`;
        }
        imageFile = BlueFlight;
        Boardpoint = movement.flight_schedule?.origin;
        Offpoint = movement.flight_schedule?.destination;
        allDateTime = movement.flight_schedule;
        previousArrival = arrivalDateTime ? `${arrivalDate}T${arrivalTime}` : null;
        departureDate = depDate;
        departureTime = depTime;
      }
      else if (movement.type === 'Truck') {
        let arrivalDate = movement.booking_truck_date_detail?.arrival_date;
        let arrivalTime = movement.booking_truck_date_detail?.arrival_time;
        let depDate = movement.booking_truck_date_detail?.departure_date;
        let depTime = movement.booking_truck_date_detail?.departure_time;
        if (previousArrival && depDate && depTime) {
          let prev = new Date(previousArrival);
          let curr = new Date(`${depDate}T${depTime}`);
          let diffMinutes = (curr - prev) / (1000 * 60);
          connectionTime = (diffMinutes >= 0 ? '' : '-') + formatMinutesToHHMM(Math.abs(diffMinutes));
          connectionDetailsTime = (diffMinutes >= 0 ? '' : '-') + "Prev-" + previousArrival + "<br/>Curr" + `${depDate}T${depTime}`;
        }
        imageFile = CargoTruck;
        Boardpoint = movement.booking_truck_date_detail?.booking_truck_details?.board_point_station?.station_code;
        Offpoint = movement.booking_truck_date_detail?.booking_truck_details?.off_point_station?.station_code || '';
        allDateTime = movement.booking_truck_date_detail;
        previousArrival = arrivalDate && arrivalTime ? `${arrivalDate}T${arrivalTime}` : null;
        departureDate = depDate;
        departureTime = depTime;
      }
      let className = "";
      if (connectionTime) {
        const [hours, minutes] = connectionTime.split(':').map(Number);
        if (hours < 10) {
          className = "error_connection_tym";
        } else {
          className = "success_connection_tym";
        }
        htmlContent += `<div class='${className} d-flex justify-content-between'><span>Connection Time -</span>
                                                      <span>${connectionTime}</span></div><p class="d-none">${connectionDetailsTime}</p>`;
      }
      htmlContent += `<div class='route_segment_list'>
                                  <h6>${movement.flight_truck_no} / ${movement.date}</h6>
                                  <div class='Boardpoint_offpoint_dv d-flex justify-content-between align-items-center'>
                                      <div class='boardpoint_station'>
                                          <p>Boardpoint</p>
                                          <h5>${Boardpoint || ''}</h5>
                                      </div>`;
      if (movement.type === 'Truck') {
        htmlContent += `<div class='flight_details'>
                                              <p class='flign_no_tym'><span>DEP:</span> ${movement.booking_truck_date_detail?.departure_date + " " + formatTime(movement.booking_truck_date_detail?.departure_time) || ''}</p>
                                              <img src='${CargoTruck} alt='cargo_truck'/>
                                              <p class='flign_no_tym'><span>ARR:</span>   ${movement.booking_truck_date_detail?.arrival_date + " " + formatTime(movement.booking_truck_date_detail?.arrival_time) || ''}</p>
                                          </div>`;

      } else if (movement.type === 'Flight') {
        htmlContent += `<div class='flight_details'>
                                              <p class='flign_no_tym'> <span>DEP:</span> ${movement.flight_schedule?.departure_date_utc || ''}</p>
                                              <img src='${BlueFlight}'  class="blueflight" alt='blue_flight'/>
                                              <p class='flign_no_tym'> <span>ARR:</span> ${movement.flight_schedule?.arrival_date_utc || ''}</p>
                                          </div>`;
        Offpoint = movement.flight_schedule?.destination;
      }
      htmlContent += `<div class='offpoint_station'>
                                          <p>Offpoint</p>
                                          <h5>${Offpoint || ''}</h5>
                                      </div>
                                  </div>
                              </div>`;
      setHtmlContent(htmlContent);

      if (movement.type === "Flight") {
        const o = movement.flight_schedule?.origin_details;
        const d = movement.flight_schedule?.destination_details;
        if (o && d) {
          return {
            type: "Flight",
            from_station: movement.flight_schedule?.origin_details?.code,
            to_station: movement.flight_schedule?.destination_details?.code,
            from: [o.lat ?? '0', o.lon ?? '0'],
            to: [d.lat ?? '0', d.lon ?? '0'],
            color: "blue",
            info: movement, // Fixed: was 'move', should be 'movement'
          };
        }
      }
      if (movement.type === "Truck") {
        const b = movement.booking_truck_date_detail?.booking_truck_details?.board_point_station?.station_details;
        const off = movement.booking_truck_date_detail?.booking_truck_details?.off_point_station?.station_details;
        if (b && off) {
          return {
            type: "Truck",
            from: [b.lat ?? '0', b.lon ?? '0'],
            to: [off.lat ?? '0', off.lon ?? '0'],
            from_station: movement.booking_truck_date_detail?.booking_truck_details?.board_point_station?.station_details?.code,
            to_station: movement.booking_truck_date_detail?.booking_truck_details?.off_point_station?.station_details?.code,
            color: "green",
            info: movement, // Fixed: was 'move', should be 'movement'
          };
        }
      }

      return null; // Return null for unmatched types
    }).filter(Boolean);
    setRoutes(routes);
    console.log(routes);
    // isMounted.current = true;
  }, [fData]); //detailsData

  const formatMinutesToHHMM = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  };
  function formatTime(timeStr) {
    console.log("🚀 ~ formatTime ~ timeStr:", timeStr)
    if (!timeStr) return '';
    const parts = timeStr.split(':');
    if (parts.length >= 2) {
      const hours = parts[0].padStart(2, '0');
      const minutes = parts[1].padStart(2, '0');
      return `${hours}:${minutes}`;
    }
    return timeStr;
  }
  return (
    <div className="p-2">
      <Row>
        <Col sm={3} className='p-0'>
        <div className='truck_acordian'>
          {awbDetails?.map((awb, index) => (
            <Accordion key={awb.id} className="mb-2 del-acc">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <Row className="w-100 align-items-center justify-content-between">
                    <Col xs={8}>
                      <div className='deli-dl d-flex'>
                        <div className='deli-icon-wrap'>
                          <div className='deli-icon'>
                            <img src={pieces} alt="pieces" />
                          </div>
                        </div>
                        <div className='deli-dl-text align-items-center'>
                          <h3>{awb.status_type}</h3>
                          <h4>{awb.last_update !== "0000-00-00 00:00:00" ? awb.last_update : "N/A"}</h4>
                        </div>
                      </div>
                    </Col>
                    <Col xs={3} className="text-end">
                      <span className="badge badge-ams">{awb.station}</span>
                    </Col>
                  </Row>
                </Accordion.Header>
                <Accordion.Body>
                  <Row className="mb-2 justify-content-between">
                    <Col xs={4}>
                      <div className='dlv-pis'>
                        <h4>Pieces</h4>
                      </div>
                    </Col>
                    <Col xs={8}>
                      <div className='dlv-num grn'>
                        <h4>{awb.total_actual_pieces_awb}/{awb.total_pieces_awb}</h4>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={4}>
                      <div className='dlv-pis'>
                        <h4>Flight No.</h4>
                      </div>
                    </Col>
                    <Col xs={8}>
                      <div className='dlv-num'>
                        <h4>{awb.flight_no || "N/A"}</h4>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={4}>
                      <div className='dlv-pis'>
                        <h4>ULD No.</h4>
                      </div>
                    </Col>
                    <Col xs={8}>
                      <div className='dlv-num'>
                        <h4>{awb.uld_no || "N/A"}</h4>
                      </div>
                    </Col>
                  </Row>
                  {awb?.raw.map((r) => (
                    <div key={r.id} className="p-2 border bg-wt mb-2 d-flex justify-content-between">
                      <div className='dlv-qn-wrap'>
                        <div className='dlv-qn'>
                          <h3>
                            <span>
                              <img src={pieces} alt="Pieces" className='piece_imgs' />
                            </span>
                            {r.total_pieces_message} Pieces / {r.total_weight_message} KG
                          </h3>
                          <h4>{r.uld_no || "N/A"}</h4>
                        </div>
                      </div>
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ))}
          </div>
        </Col>
        <Col sm={9} className='pe-0'>
          <div className='dlv-map'>
            <MapContainer className='map-main'
              center={[45.9234, 6.6849]}
              zoom={3}
              scrollWheelZoom={true}
              style={{ height: "400px", width: "100%" }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {/* <FitBounds positions={positions} /> */}

              {routes?.map((item, i) => (
                <>
                  <Marker position={item.from} key={i}>
                    <Popup>
                      <div className='popup-d'>
                        <ul>
                          <li>
                            <span className='popup-lft'>Station</span>
                            <span className='popup-rit popup-rit-1'>{item.from_station}</span>
                          </li>
                          <li>
                            <span className='popup-lft'>Flight No.</span>
                            <span className="popup-rit popup-rit-1">
                              <FontAwesomeIcon icon={item.type === "Truck" ? faTruck : faPlane} />
                              {item.flight_truck_no}
                            </span>
                          </li>
                          <li>
                            <span className='popup-lft'>Activity</span>
                            <span className='popup-rit popup-rit-1'>{item.shipment_type}</span>
                          </li>
                          <li>
                            <span className='popup-lft'>Date</span>
                            <span className='popup-rit popup-rit-1'>{item.info.date}</span>
                          </li>
                        </ul>
                      </div>
                    </Popup>
                  </Marker>
                  <Marker position={item.to}>
                    <Popup>
                      <div className='popup-d'>
                        <ul>
                          <li>
                            <span className='popup-lft'>Station</span>
                            <span className='popup-rit popup-rit-1'>{item.to_station}</span>
                          </li>
                          <li>
                            <span className='popup-lft'>Flight No.</span>
                            <span className="popup-rit popup-rit-1">
                              <FontAwesomeIcon icon={item.type === "Truck" ? faTruck : faPlane} />
                              {item.flight_truck_no}
                            </span>
                          </li>
                          <li>
                            <span className='popup-lft'>Activity</span>
                            <span className='popup-rit popup-rit-1'>{item.shipment_type}</span>
                          </li>
                          <li>
                            <span className='popup-lft'>Date</span>
                            <span className='popup-rit popup-rit-1'>{item.info.date}</span>
                          </li>
                        </ul>
                      </div>
                    </Popup>
                  </Marker>
                  <Polyline positions={[item.from, item.to]} color={item.color} />
                </>
              ))}





            </MapContainer>
            <div className="mt-3 shipmentChanges awbhanges d-flex bg-white" style={{ position: 'absolute', top: '0', zIndex: '999', right: '10px' }}>
              <div className="mainDiv" onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
                <h4 className="writing-vertical m-0">
                  <span>Route Shipment</span>
                  <FontAwesomeIcon icon={faAnglesLeft} className={`mt-2 transition-icon ${open ? "rotated" : ""}`} />
                </h4>
              </div>
              <div className={`shipmentChangesContainer forawb ${open ? "opened" : "closed"}`}>

                <h3>Route Shipment</h3>
                <p className='text-muted'>Changes detected in assigned shipment</p>
                <div className="pallet_hv route_shipment_segment_dv">
                  <h5><span>{fData?.ULD?.airway_bill} -</span> <span>Route Shipment</span></h5>

                  <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                </div>

              </div>
            </div>
            {/* Progress Bar Start*/}
            {/* <div className="st-card">
              <div className="st-header">
                <div className="st-header-left">
                  
                  <div className='tckicon-wrap'>
                    <div className='tckicon'>
                      <img src={shipment_tracking}></img>
                    </div>
                  </div>
                  <span className="st-title">Live Shipment Tracking</span>
                </div>
                <button className="st-close" aria-label="Close">
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
              <div className='st-box-dv'>
                <div className="st-top">
                  <div className="st-col">
                    <div className="st-label">Origin</div>
                    <div className="st-code">AMS</div>
                  </div>

                  <div className="st-col">
                    <div className="st-transport">
                      <FontAwesomeIcon icon={faTruck} /> <span>ZZZ-529 (Truck)</span>
                    </div>
                  </div>
                  <div className="st-col st-center">
                    <div className="st-label">Station</div>
                    <div className="st-code">CDG</div>
                  </div>

                  <div className="st-col">
                    <div className="st-transport">
                      <FontAwesomeIcon icon={faPlane} /> <span>AA-123 (Flight)</span>
                    </div>
                  </div>

                  <div className="st-col st-right">
                    <div className="st-label">Destination</div>
                    <div className="st-code">HKG</div>
                  </div>
                </div>
                <div className="st-track" style={{ "--progress": "45%" }}>
                  <div className="st-node st-node--done" />
                  <div className="st-leg st-leg--done" />
                  <div className="st-node st-node--done" />
                  <div className="st-leg st-leg--right">
                    <FontAwesomeIcon icon={faPlane} className="st-plane" />
                  </div>
                  <div className="st-node st-node--dest" />
                </div>
                <div className='st-bottom-div'>
                  <div className="st-bottom">
                    <div className="st-tile">
                      <div className="st-meta">
                        <div className="st-meta-label">STA/ Date</div>
                        <div className="st-time">10:45</div>
                        <div className="st-date">26-08-2025</div>
                      </div>
                    </div>
                    <div className="st-tile">
                      <div className="st-meta text-end">
                        <div className="st-meta-label">ETA/ Date</div>
                        <div className="st-time">10:42</div>
                        <div className="st-date">27-08-2025</div>
                      </div>
                    </div>
                  </div>
                  <div className='st-bottom-1'></div>
                  <div className="st-bottom">
                    <div className="st-tile">
                      <div className="st-meta">
                        <div className="st-meta-label">STA/ Date</div>
                        <div className="st-time">10:45</div>
                        <div className="st-date">26-08-2025</div>
                      </div>
                    </div>
                    <div className="st-tile">
                      <div className="st-meta text-end">
                        <div className="st-meta-label">ETA/ Date</div>
                        <div className="st-time">02:50</div>
                        <div className="st-date">26-08-2025</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Overview